module.exports = __webpack_public_path__ + "static/img/10.b76587f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/eng/10.png
// module id = K5AL
// module chunks = 0